import FileUploadInput from './FileUploadInput';

export default FileUploadInput;
